import type { GameMode } from '@tm/shared';
import type { Me } from '../lib/api.js';

interface ModeCard {
  mode: GameMode;
  icon: string;
  title: string;
  hint: string;
}

const MODES: ModeCard[] = [
  { mode: 'practice', icon: '🎯', title: 'Тренировка', hint: '15 примеров под твой уровень' },
  { mode: 'sprint', icon: '⚡', title: 'Спринт', hint: 'Сколько успеешь за минуту' },
  { mode: 'ladder', icon: '🧗', title: 'Лестница', hint: 'Таблицы по очереди' },
  { mode: 'duel', icon: '⚔️', title: 'Дуэль с другом', hint: 'Одинаковые примеры у обоих' },
];

export function Home({
  me,
  onPlay,
  onDuels,
}: {
  me: Me;
  onPlay: (mode: GameMode, opts?: { table?: number }) => void;
  onDuels: () => void;
}) {
  const d = me.daily;
  const left = Math.max(0, d.goal - d.done);
  const pct = Math.min(100, (d.done / Math.max(1, d.goal)) * 100);

  return (
    <div className="stack">
      <div className="row between">
        <h1>Привет, {me.user.firstName || 'друг'}!</h1>
        {d.currentStreak > 0 && <span className="pill">🔥 {d.currentStreak}</span>}
      </div>

      <div className="card">
        <div className="row between">
          <h3>Задание дня</h3>
          <span className="small dim">{d.done} / {d.goal}</span>
        </div>
        <div className="progress" style={{ marginTop: 10 }}>
          <i style={{ width: `${pct}%` }} />
        </div>
        <p className="small dim" style={{ margin: '9px 0 0' }}>
          {d.completed
            ? `Готово! Серия — ${d.currentStreak} ${plural(d.currentStreak, 'день', 'дня', 'дней')} подряд 🎉`
            : `Осталось ${left} ${plural(left, 'пример', 'примера', 'примеров')}`}
        </p>
        {!d.completed && (
          <button className="btn" style={{ marginTop: 11 }} onClick={() => onPlay('daily')}>
            📅 Выполнить задание
          </button>
        )}
      </div>

      <div className="modes">
        {MODES.map((m) => (
          <button
            key={m.mode}
            className="mode"
            onClick={() => (m.mode === 'duel' ? onDuels() : onPlay(m.mode, { table: m.mode === 'ladder' ? me.ladderLevel : undefined }))}
          >
            <span className="ico">{m.icon}</span>
            <span className="grow">
              <span className="t" style={{ display: 'block' }}>{m.title}</span>
              <span className="d">
                {m.mode === 'ladder' ? `Сейчас: таблица на ${me.ladderLevel}` : m.hint}
              </span>
            </span>
            <span className="dim">›</span>
          </button>
        ))}
      </div>

      {me.user.bestSprintScore > 0 && (
        <p className="small dim center">Рекорд спринта: {me.user.bestSprintScore} очков</p>
      )}
    </div>
  );
}

export function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}
